import { AnnotationLayerActions, AnnotationLayerStoreSubscriber, type AnnotationLayerData } from "@zebrabi/annotation-layer";

/**
 * Subscribes the add-in to the annotation layer store. The charts renderers decide at render time whether the CAGR
 * arrow gets its hover toolbar and whether the transparent grid is drawn, so the chart redraws whenever the floating
 * menu opens or closes. The menu's Info links leave through the host, which Office has to open itself.
 */
export function createAnnotationLayerStoreSubscriber(
    redrawChart: () => void,
    openUrl: (url: string) => void
): AnnotationLayerStoreSubscriber {
    const subscriber = new AnnotationLayerStoreSubscriber();
    const handlers: Partial<Record<AnnotationLayerActions, (payload: AnnotationLayerData) => void>> = {
        [AnnotationLayerActions.FloatingMenuOpened]: redrawChart,
        [AnnotationLayerActions.FloatingMenuClosed]: redrawChart,
        [AnnotationLayerActions.LaunchUrl]: (payload: AnnotationLayerData) => {
            if (typeof payload.value === "string") {
                openUrl(payload.value);
            }
        },
    };

    subscriber.update = (payload: AnnotationLayerData) => {
        handlers[payload.action]?.(payload);
    };

    return subscriber;
}
